import { render, staticRenderFns } from "./PostsHome.vue?vue&type=template&id=05ec9382&scoped=true&lang=pug&"
import script from "./PostsHome.vue?vue&type=script&lang=js&"
export * from "./PostsHome.vue?vue&type=script&lang=js&"
import style0 from "./PostsHome.vue?vue&type=style&index=0&id=05ec9382&lang=scss&scoped=true&"
import style1 from "./PostsHome.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ec9382",
  null
  
)

export default component.exports